module.exports = __webpack_public_path__ + "img/EQUA.4cd1712f.svg";